import { jsx } from "react/jsx-runtime";
import { Children } from "react";
import { SpaceMd, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { AD_TYPE_ONE_FOURTH_MIX } from "../../constants.js";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
const OneFourthMix = ({
  children
}) => {
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        display: "flex",
        flexWrap: "wrap",
        gap: {
          md: SpaceLg,
          xs: SpaceMd
        },
        overflow: "hidden"
      },
      "data-layout": AD_TYPE_ONE_FOURTH_MIX,
      children: Children.map(children, (child, index) => {
        return /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              display: "flex",
              flex: {
                // Half the gap on parent container
                md: `calc(50% - 12px)`,
                xs: `calc(50% - 8px)`
              },
              maxWidth: {
                // Half the gap on parent container
                md: `calc(50% - 12px)`,
                xs: `calc(50% - 8px)`
              }
            },
            children: child
          },
          index
        );
      })
    }
  );
};
export {
  OneFourthMix
};
